import type { Application } from '@src/@types/app';
import { MODES } from '@src/constants/filters';
import { getHasUtmLabel } from '@src/reducers/route';

export const getFilterMode = (ctx: Application.ReduxNextPageContext) =>
  getHasUtmLabel(ctx.store.getState()) ? MODES.AS_UTM : MODES.DEFAULT;
